import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import MLRODashboard from './MLRODashboard';
import JaybeeReview from './JaybeeReview';
import DirectorReview from './DirectorReview';
import BankingApp from './BankingApp';

class ErrorBoundary extends React.Component {
  constructor(props) { super(props); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e.message }; }
  render() {
    if (this.state.error) return <div style={{padding:40,fontFamily:'Arial',color:'#dc2626',fontSize:14}}>Page error: {this.state.error}</div>;
    return this.props.children;
  }
}

function Router() {
  const [path, setPath] = React.useState(window.location.pathname);
  
  React.useEffect(() => {
    const handler = () => setPath(window.location.pathname);
    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, []);

  if (path === '/mlro' || path === '/mlro/') {
    return <ErrorBoundary><MLRODashboard /></ErrorBoundary>;
  }
  if (path === '/review') {
    return <ErrorBoundary><JaybeeReview /></ErrorBoundary>;
  }
  if (path === '/director-review') {
    return <ErrorBoundary><DirectorReview /></ErrorBoundary>;
  }
  if (path === '/banking' || path === '/banking/') {
    return <ErrorBoundary><BankingApp /></ErrorBoundary>;
  }
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<Router />);
